import { PlatformManifest } from "expo-constants";
import { Platform } from "react-native";

export enum PlatformType {
  IOS = "ios",
  ANDROID = "android",
  WEB = "web",
  UNKNOWN = "unknown",
}

export function getPlatformTypeFromExpo(
  platform: PlatformManifest | undefined,
): PlatformType {
  // Check for iOS platform
  if (platform?.ios) {
    return PlatformType.IOS;
  }

  // Check for Android platform
  if (platform?.android) {
    return PlatformType.ANDROID;
  }

  if (platform?.web) {
    return PlatformType.WEB;
  }

  return PlatformType.UNKNOWN;
}

export function isWeb(): boolean {
  return Platform.OS === "web";
}

export function isiOS(): boolean {
  return Platform.OS === "ios";
}

export function isAndroid(): boolean {
  return Platform.OS === "android";
}

export function isMobileApp(): boolean {
  return isiOS() || isAndroid();
}
